import { render, staticRenderFns } from "./ListBaseFretebasEmpresaView.vue?vue&type=template&id=5a20a8a0&"
import script from "./ListBaseFretebasEmpresaView.vue?vue&type=script&lang=ts&"
export * from "./ListBaseFretebasEmpresaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports